<template>
  <div
    @mouseenter="hoverOnImg = true"
    @mouseleave="hoverOnImg = false"
    @click="
      showMustGoOn(itemShowIt || itemSrc, itemZoom);
      goTo(itemGoTo);
    "
  >
    <img
      class="imgColor"
      @load="changeCanShowIt"
      :style="{
        width: '100%',
        height: '100%',
        position: 'absolute',
        left: '0%',
        top: '0%',
        cursor: 'pointer',
        objectPosition: 'left bottom',
        animationDelay: ((itemStyle.delay + 100) | 0) / 100 + 's',
      }"
      :src="itemSrc"
    />
    <svg
      :style="{
        width: '100%',
        height: '100%',
        background: '',
      }"
      viewBox="0 0 120 120"
    >
      <g class="isolate">
        <circle
          id="yellow"
          cx="85"
          cy="85"
          r="35"
          fill="rgba(237, 206, 0,1)"
          :style="{ animationDelay: ((itemStyle.delay + 100) | 0) / 100 + 's' }"
        />
        <!-- blue -->
        <circle
          id="blue"
          cx="60"
          cy="45"
          r="35"
          fill="rgba(72, 90, 167,1)"
          :style="{ animationDelay: ((itemStyle.delay + 100) | 0) / 100 + 's' }"
        />
        <!-- red -->
        <circle
          id="red"
          cx="35"
          cy="85"
          r="35"
          fill="rgba(226, 12, 67,1)"
          :style="{ animationDelay: ((itemStyle.delay + 100) | 0) / 100 + 's' }"
        />
        <!-- yellow -->
      </g>
    </svg>
    <transition name="info-fade">
      <svg
        v-if="itemZoom && canShowIt && hoverOnImg"
        :style="{
          width: '100px',
          height: '100px',
          cursor: 'pointer',
          objectPosition: itemStyle.objectPosition | 'left bottom',
        }"
        viewBox="0 0 24 24"
        style="position: absolute; top: calc(50% - 50px); left: calc(50% - 50px); transition: 0.3s"
      >
        <path
          fill="rgba(255,255,255, 0.3)"
          stroke="rgba(0,0,0,0.5)"
          stroke-width=".3"
          d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
        />
      </svg>
    </transition>
  </div>
</template>
<script>
export default {
  name: 'color-mix',
  props: {
    itemStyle: {
      default: () => {
        return null;
      },
      type: Object,
    },
    itemShowIt: {
      default: () => {
        return null;
      },
      type: String,
    },
    itemZoom: {
      default: () => {
        return false;
      },
      type: Boolean,
    },
    itemSrc: {
      default: () => {
        return null;
      },
      type: String,
    },
    itemGoTo: {
      default: () => {
        return null;
      },
      type: Number,
    },
  },
  data() {
    return { canShowIt: false, hoverOnImg: false };
  },
  methods: {
    changeCanShowIt() {
      let time = (this.itemStyle.delay | 0) * 10 + 2100;
      setTimeout(() => {
        this.canShowIt = true;
      }, time);
    },
    goTo(go) {
      if (go) {
        this.$parent.$parent.$parent.$parent.$emit('goToStepNow', go);
        this.$store.commit('STATE_SET_GO_TO', go);
      }
    },
    showMustGoOn(img, zoom) {
      // console.log(img);
      // console.log(zoom);
      if (zoom) {
        this.$store.commit('STATE_SET_IMG_TO_SHOW', img);
        this.$store.commit('STATE_SET_GALERY_OPEN', true);
      }
    },
  },
};
</script>
<style lang="sass">
@import '../../style/base'
@import '../../style/animation'
circle
  // mix-blend-mode: screen
.isolate
  // isolation: isolate
  #blue
    animation-name: blueBall
    animation-duration: 2s
    animation-iteration-count: 1
    transform-origin: center
    opacity: 0
    animation-fill-mode: forwards
  #red
    animation-name: redBall
    animation-duration: 2s
    animation-iteration-count: 1
    transform-origin: center
    opacity: 0
    animation-fill-mode: forwards
  #yellow
    animation-name: yellowBall
    animation-duration: 2s
    animation-iteration-count: 1
    transform-origin: center
    opacity: 0
    animation-fill-mode: forwards
.imgColor
  animation-name: imgColorAnim
  animation-duration: 2s
  animation-iteration-count: 1
  transform-origin: center
  opacity: 0
  animation-fill-mode: forwards

@keyframes blueBall
  0%
    transform: translateY(-50%)
    opacity: 0
  100%
    transform: translateY(0%)
    opacity: 1
@keyframes redBall
  0%
    transform: translateY(50%) translateX(-50%)
    opacity: 0
  100%
    transform: translateY(0%)
    opacity: 1
@keyframes yellowBall
  0%
    transform: translateY(50%) translateX(50%)
    opacity: 0
  100%
    transform: translateY(0%)
    opacity: 1
@keyframes imgColorAnim
  0%
    opacity: 0
  69%
    opacity: 0
  100%
    opacity: 1
</style>
